import React from 'react';
import { Icon, IdsIconsDefinition } from '@ids/react-icon';
import { Render } from '../../types';
import classnames from 'classnames';

export function IconDisplay(props: Readonly<{ iconProp: IdsIconsDefinition; additionalClassName?: string }>): Render {
  // prettier-ignore
  return  <Icon className={classnames('if workshop-icon mr-8', props.additionalClassName)} {...props.iconProp} />;
}
